/*
 * @Author: zhou lei
 * @Date: 2022-04-14 13:23:44
 * @LastEditTime: 2024-01-18 17:07:59
 * @LastEditors: zhou lei
 * @Description:
 * @FilePath: /mmeui/src/i18n/en.js
 * 联系方式:910592680@qq.com 18669792120 科海达信息技术有限公司
 */
export default {
  login: {
    登录: 'Sign in',
    注册: 'Register',
    用户名: 'Username',
    密码: 'Password',
    请选择: 'Select',
    中文: 'Chinese',
    英文: 'English',
    用户注册: 'Register',
    手机号: 'Tel',
    验证码: 'Verification Code',
    取消: 'Cancel',
    确定: 'Confirm',
    支付页面: 'Payment Page',
    获取验证码: 'Send Verification Code'
  },
  changepwd: {
    首页: 'Home',
    修改密码: 'Change Password',
    用户名: 'Username',
    旧密码: 'Current Password',
    新密码: 'New Password',
    确认修改: 'Change Password'
  },
  account: {
    首页: 'Home',
    设备激活: 'Activate Device',
    激活码激活: 'Use Activation Code',
    设备编号: 'Device Number',
    激活码: 'Activation Code',
    激活账号: 'Activate Account',
    批量激活: 'Volume Activation',
    选择文件: 'Select Document',
    开始上传: 'Uploading',
    下载导入模板: 'Download Import Template',
    信息提示: 'Tips',
    当前限制选择1个文件: 'Only one document are allowed to select',
    本次选择了: 'You have selected ',
    个文件: 'document(s)',
    共选择了: 'Totally select'
  },
  map: {
    首页: 'Home',
    地图: 'Map',
    开始日期: 'Start Date',
    至: 'to',
    结束日期: 'End Date',
    确定: 'Confirm',
    显示卫星图: 'Display Satellite Imagery ',
    设备名称: 'Device Name',
    经纬度: 'Longitude and Latitude',
    时间: 'Time',
    '1/3波高': '1/3 Wave Height',
    '1/3波周期': '1/3 Wave Period',
    '1/10波高': '1/10 Wave Height',
    '1/10波周期': '1/10 Wave Period',
    最大波高: 'Max Wave Height',
    最大波周期: 'Max Wave Period',
    平均波高: 'Mean Wave Height',
    平均波周期: 'Mean Wave Period',
    涌浪波高: 'Swell Wave Height',
    涌浪波周期: 'Swell Wave Period',
    波向: 'Wave Direction',
    电压值: 'Volts',
    温度: 'Temperature',
    '1/3 Wave Height(m)': '1/3 Wave Height(m)',
    '1/3 Wave Period(s)': '1/3 Wave Period(s)',
    '1/10 Wave Height(m)': '1/10 Wave Height(m)',
    '1/10 Wave Period(s)': '1/10 Wave Period(s)',
    'Max Wave Height(m)': 'Max Wave Height(m)',
    'Max Wave Period(s)': 'Max Wave Period(s)',
    'Mean Wave Height (m)': 'Mean Wave Height (m)',
    'Mean Wave Period (s)': 'Mean Wave Period (s)',
    'Surge Wave Height (m)': 'Surge Wave Height (m)',
    'Surge Wave Period (s)': 'Surge Wave Period (s)',
    'Wave Direction': 'Wave Direction',
    'Surface Temp (℃)': 'Surface Temp (℃)',
    'voltage value (V)': 'voltage value (V)',
    'Wind Direction': 'Wind Direction',
    'Wind Speed (m/s)': 'Wind Speed (m/s)',
    'Air Pressure(hPa)': 'Air Pressure(hPa)',
    'Relative humidity': 'Relative humidity',
    'Temp(℃)': 'Temp(℃)',
    'Currents Velocity01(mm/s)': 'Currents Velocity01(mm/s)',
    'Currents Velocity02(mm/s)': 'Currents Velocity02(mm/s)',
    'Currents Velocity03(mm/s)': 'Currents Velocity03(mm/s)',
    'Currents Velocity04(mm/s)': 'Currents Velocity04(mm/s)',
    'Currents Velocity05(mm/s)': 'Currents Velocity05(mm/s)',
    'Currents Velocity06(mm/s)': 'Currents Velocity06(mm/s)',
    'Currents Velocity07(mm/s)': 'Currents Velocity07(mm/s)',
    'Currents Velocity08(mm/s)': 'Currents Velocity08(mm/s)',
    'Currents Velocity09(mm/s)': 'Currents Velocity09(mm/s)',
    'Currents Velocity10(mm/s)': 'Currents Velocity10(mm/s)',
    'Currents Velocity11(mm/s)': 'Currents Velocity11(mm/s)',
    'Currents Velocity12(mm/s)': 'Currents Velocity12(mm/s)',
    'Currents Velocity13(mm/s)': 'Currents Velocity13(mm/s)',
    'Currents Velocity14(mm/s)': 'Currents Velocity14(mm/s)',
    'Currents direction01(°)': 'Currents direction01(°)',
    'Currents direction02(°)': 'Currents direction02(°)',
    'Currents direction03(°)': 'Currents direction03(°)',
    'Currents direction04(°)': 'Currents direction04(°)',
    'Currents direction05(°)': 'Currents direction05(°)',
    'Currents direction06(°)': 'Currents direction06(°)',
    'Currents direction07(°)': 'Currents direction07(°)',
    'Currents direction08(°)': 'Currents direction08(°)',
    'Currents direction09(°)': 'Currents direction09(°)',
    'Currents direction10(°)': 'Currents direction10(°)',
    'Currents direction11(°)': 'Currents direction11(°)',
    'Currents direction12(°)': 'Currents direction12(°)',
    'Currents direction13(°)': 'Currents direction13(°)',
    'Currents direction14(°)': 'Currents direction14(°)',
    //设备Met Buoy参数
    'Mean Wave Height(m)': 'Mean Wave Height(m)',
    'Mean Wave Period(s)': 'Mean Wave Period(s)',
    'Surge Wave Height(m)': 'Surge Wave Height(m)',
    'Surge Wave Period(s)': 'Surge Wave Period(s)',
    'Surface Temp(℃)': 'Surface Temp(℃)',
    'Wind Speed(m/s)': 'Wind Speed(m/s)',
    'Wave Direction(°)': 'Wave Direction(°)',
    'Voltage Value(V)': 'Voltage Value(V)',
    'Weather Status': 'Weather Status',
    'Wave Status': 'Wave Status',
    'GPS Status': 'GPS Status',
    'ADCP Status': 'ADCP Status',
    'Current Velocity 01(mm/s)': 'Current Velocity 01(mm/s)',
    'Current Velocity 02(mm/s)': 'Current Velocity 02(mm/s)',
    'Current Velocity 03(mm/s)': 'Current Velocity 03(mm/s)',
    'Current Velocity 04(mm/s)': 'Current Velocity 04(mm/s)',
    'Current Velocity 05(mm/s)': 'Current Velocity 05(mm/s)',
    'Current Velocity 06(mm/s)': 'Current Velocity 06(mm/s)',
    'Current Velocity 07(mm/s)': 'Current Velocity 07(mm/s)',
    'Current Velocity 08(mm/s)': 'Current Velocity 08(mm/s)',
    'Current Velocity 09(mm/s)': 'Current Velocity 09(mm/s)',
    'Current Velocity 10(mm/s)': 'Current Velocity 10(mm/s)',
    'Current Velocity 11(mm/s)': 'Current Velocity 11(mm/s)',
    'Current Velocity 12(mm/s)': 'Current Velocity 12(mm/s)',
    'Current Velocity 13(mm/s)': 'Current Velocity 13(mm/s)',
    'Current Velocity 14(mm/s)': 'Current Velocity 14(mm/s)',
    'Current Velocity 15(mm/s)': 'Current Velocity 15(mm/s)',
    'Current Velocity 16(mm/s)': 'Current Velocity 16(mm/s)',
    'Current Velocity 17(mm/s)': 'Current Velocity 17(mm/s)',
    'Current Velocity 18(mm/s)': 'Current Velocity 18(mm/s)',
    'Current Velocity 19(mm/s)': 'Current Velocity 19(mm/s)',
    'Current Velocity 20(mm/s)': 'Current Velocity 20(mm/s)',
    'Current Velocity 21(mm/s)': 'Current Velocity 21(mm/s)',
    'Current Velocity 22(mm/s)': 'Current Velocity 22(mm/s)',
    'Current Velocity 23(mm/s)': 'Current Velocity 23(mm/s)',
    'Current Velocity 24(mm/s)': 'Current Velocity 24(mm/s)',
    'Current Velocity 25(mm/s)': 'Current Velocity 25(mm/s)',
    'Current Direction 01(°)': 'Current Direction 01(°)',
    'Current Direction 02(°)': 'Current Direction 02(°)',
    'Current Direction 03(°)': 'Current Direction 03(°)',
    'Current Direction 04(°)': 'Current Direction 04(°)',
    'Current Direction 05(°)': 'Current Direction 05(°)',
    'Current Direction 06(°)': 'Current Direction 06(°)',
    'Current Direction 07(°)': 'Current Direction 07(°)',
    'Current Direction 08(°)': 'Current Direction 08(°)',
    'Current Direction 09(°)': 'Current Direction 09(°)',
    'Current Direction 10(°)': 'Current Direction 10(°)',
    'Current Direction 11(°)': 'Current Direction 11(°)',
    'Current Direction 12(°)': 'Current Direction 12(°)',
    'Current Direction 13(°)': 'Current Direction 13(°)',
    'Current Direction 14(°)': 'Current Direction 14(°)',
    'Current Direction 15(°)': 'Current Direction 15(°)',
    'Current Direction 16(°)': 'Current Direction 16(°)',
    'Current Direction 17(°)': 'Current Direction 17(°)',
    'Current Direction 18(°)': 'Current Direction 18(°)',
    'Current Direction 19(°)': 'Current Direction 19(°)',
    'Current Direction 20(°)': 'Current Direction 20(°)',
    'Current Direction 21(°)': 'Current Direction 21(°)',
    'Current Direction 22(°)': 'Current Direction 22(°)',
    'Current Direction 23(°)': 'Current Direction 23(°)',
    'Current Direction 24(°)': 'Current Direction 24(°)',
    'Current Direction 25(°)': 'Current Direction 25(°)'
    //
  },
  detail: {
    首页: 'Home',
    测试页面: 'Test Page',
    配置参数: 'Configuration Parameters',
    设备名: 'Device Name',
    设备编号: 'Device Number',
    设备名称: 'Device ',
    北斗更新时间: 'Beidou Update Time',
    整点: `(o'clock)`,
    时间: 'Time',
    偏移量: 'Offset',
    米: '(Metre)',
    终端采样频率: 'Terminal Sampling Frequency',
    分: '(Minute)',
    基准纬度: 'Standard Latitude',
    度: '(Degree)',
    基准经度: 'Standard longitude',
    无信号报警间隔: 'No signal alarm interval',
    报警刷新时间: 'Alarm Refresh Time',
    查看: 'View',
    偏移报警: 'Offset Alarm',
    超时报警: 'Timeout Alarm',
    开舱漏水报警: 'Open cabin water leakage alarm',
    保存: 'Save',
    设备可见用户: 'Users with viewing permission',
    添加可见用户: 'Add a user with viewing permission',
    移除共享: 'Remove Sharing',
    设备数据: 'Device Data',
    开始日期: 'Start Date',
    至: 'to',
    结束日期: 'End Date',
    确定: 'Confirm',
    经度: 'Longitude',
    纬度: 'Latitude',
    设备报表下载: 'Device Report Download',
    添加可访问用户: 'Add Accessible Users',
    设备编码: 'Device Code',
    用户名: 'Username',
    手机号: 'Tel',
    取消: 'Cancel',
    报警列表: 'Alarm List',
    设备信息表ID: 'Device Information Digram ID',
    设备类型ID: 'Device Type ID',
    GPS时间: 'GPS Time',
    一路温度: 'One-Way Temperature',
    二路温度: 'Two-Way Temperature',
    三路温度: 'Three-Way Temperature',
    一路湿度: 'One-Way Humidity',
    二路湿度: 'Two-Way Humidity',
    三路湿度: 'Three-Way Humidity',
    是否开仓: 'Open Cabin?',
    是: 'Yes',
    否: 'No',
    操作: 'operate',
    已读: 'Read',
    选择了: 'You have selected',
    操作失败: 'Operation Failed',
    报警信息提示: 'Prompt Alarm',
    修改操作成功: 'The modification operation succeeded',
    保存成功: 'Successfully saved',
    保存失败: 'Failed to save',
    这是一段内容: 'Content',
    标题名称: 'Title',
    查询数据超过6万条: 'More than 60,000 records, the first 60,000 records are being downloaded',
    风速: 'Wind Speed',
    盐度: 'Salinity',
    气压: 'Atmospheric Pressure',
    波高: 'Wave Height',
    温度: 'Temperature',
    波值: 'Wave Value',
    波周期: 'Wave Period',
    波向: 'Wave Direction',
    电压值: 'Voltage Value',
    风向: 'Wind Direction',
    '1/3波高': '1/3 Wave Height',
    '1/3波周期': '1/3 Wave Period',
    '1/10波高': '1/10 Wave Height',
    '1/10波周期': '1/10 Wave Period',
    最大波高: 'Maximum Wave Height',
    最大波周期: 'Maximum Wave Period',
    平均波高: 'Mean Wave Height',
    平均波周期: 'Mean Wave Period',
    涌浪波高: 'Surge Wave Height',
    涌浪波周期: 'Surge Wave Period',
    'CTD温度℃': 'CTD Temperature ℃',
    'CTD电导率S/m': 'CTD Conductivity S/m',
    CTD盐度PSU: 'CTD Salinity PSU',
    'ADCP温度℃': 'ADCP Temperature ℃',
    'E/W-mm/s': 'E/W-mm/s',
    'N/S-mm/s': 'N/S-mm/s',
    Vert: 'Vert',
    CR采集器温度: 'CR Collector temperature',
    CR空气温度avg: 'CR Air Temperature avg',
    CR空气湿度avg: 'CR Air Humidity avg',
    CR水汽压avg: 'CR Water Vapor Pressure avg',
    CR气压avg: 'CR Atmospheric Pressure avg',
    CR相对风速avg: 'CR Relative Wind Speed avg',
    CR相对风向avg: 'CR Relative Wind Direction avg',
    'CR实际风速avg（knots）': 'CR Actual Wind Speed avg（knots）',
    'CR实际风速avg（m/s）': 'CR Actual Wind Speed avg（m/s）',
    'CR实际风向avg（°）': 'CR Actual Wind Direction avg（°）',
    CR长波辐射avg: 'CR Longwave Radiation avg',
    CR总辐射avg: 'CR Total Radiation avg',
    CR总辐射acc: 'CR Total Radiation acc',
    CR雨量acc: 'CR Rainfall acc',
    GMX风向: 'GMX Wind Direction',
    GMX风速: 'GMX Wind Speed',
    GMX校正后风向: 'GMX Wind Direction After Correction',
    GMX气压: 'GMX Atmospheric Pressure',
    GMX相对湿度: 'GMX Relative Humidity',
    GMX温度: 'GMX Temperature',
    GMX露点温度: 'GMX Dew Point Temperature',
    GMX雨量: 'GMX Rainfall',
    GMX降雨密度: 'GMX Rainfall Density',
    温度0: 'Temperature 0',
    经度1: 'Longitude 1',
    纬度1: 'Latitude 1',
    温度1: 'Temperature 1',
    经度2: 'Longitude 2',
    纬度2: 'Latitude 2',
    温度2: 'Temperature 2',
    经度3: 'Longitude 3',
    纬度3: 'Latitude 3',
    温度3: 'Temperature 3',
    经度4: 'Longitude 4',
    纬度4: 'Latitude 4',
    温度4: 'Temperature 4',
    信息编号: 'Message Numver',
    CTD压力db: 'CTD Pressure db',
    GMX校正后风速: 'GMX Wind Speed After Correction',
    GMX风向avg: 'GMX Wind Direction avg',
    GMX风速avg: 'GMX Wind Speed avg',
    GMX校正后风向avg: 'GMX Wind Direction After Correction avg',
    GMX校正后风速avg: 'GMX Wind Speed After Correction avg',
    GMX平均纬度整数: 'GMX Mean Latitude Degree',
    GMX平均纬度分数: 'GMX Mean Latitude Minute',
    GMX平均经度整数: 'GMX Mean Longitude Degree',
    GMX平均经度分数: 'GMX Mean Longitude Minute',
    GMX平均海拔: 'GMX Average Altitude',
    GMX总雨量: 'GMX Total Rainfall',
    GMX经度: 'GMX Longitude',
    GMX纬度: 'GMX Latitude',
    GMX海拔: 'GMX Altitude',
    'E/W1-mm/s': 'E/W1-mm/s',
    'E/W2-mm/s': 'E/W2-mm/s',
    'E/W3-mm/s': 'E/W3-mm/s',
    'E/W4-mm/s': 'E/W4-mm/s',
    'E/W5-mm/s': 'E/W5-mm/s',
    'E/W6-mm/s': 'E/W6-mm/s',
    'E/W7-mm/s': 'E/W7-mm/s',
    'N/S1-mm/s': 'N/S1-mm/s',
    'N/S2-mm/s': 'N/S2-mm/s',
    'N/S3-mm/s': 'N/S3-mm/s',
    'N/S4-mm/s': 'N/S4-mm/s',
    'N/S5-mm/s': 'N/S5-mm/s',
    'N/S6-mm/s': 'N/S6-mm/s',
    'N/S7-mm/s': 'N/S7-mm/s',
    VERT1: 'VERT1',
    VERT2: 'VERT2',
    VERT3: 'VERT3',
    VERT4: 'VERT4',
    VERT5: 'VERT5',
    VERT6: 'VERT6',
    VERT7: 'VERT7',
    ERR1: 'ERR1',
    ERR2: 'ERR2',
    ERR3: 'ERR3',
    ERR4: 'ERR4',
    ERR5: 'ERR5',
    ERR6: 'ERR6',
    ERR7: 'ERR7',
    ECHO11: 'ECHO11',
    ECHO12: 'ECHO12',
    ECHO13: 'ECHO13',
    ECHO14: 'ECHO14',
    ECHO15: 'ECHO15',
    ECHO16: 'ECHO16',
    ECHO17: 'ECHO17',
    ECHO21: 'ECHO21',
    ECHO22: 'ECHO22',
    ECHO23: 'ECHO23',
    ECHO24: 'ECHO24',
    ECHO25: 'ECHO25',
    ECHO26: 'ECHO26',
    ECHO27: 'ECHO27',
    ECHO31: 'ECHO31',
    ECHO32: 'ECHO32',
    ECHO33: 'ECHO33',
    ECHO34: 'ECHO34',
    ECHO35: 'ECHO35',
    ECHO36: 'ECHO36',
    ECHO37: 'ECHO37',
    ECHO41: 'ECHO41',
    ECHO42: 'ECHO42',
    ECHO43: 'ECHO43',
    ECHO44: 'ECHO44',
    ECHO45: 'ECHO45',
    ECHO46: 'ECHO46',
    ECHO47: 'ECHO47',
    包号: 'Datagram Number',
    谱峰周期: 'Spectral Peak Period',
    机械风风速: 'Mechanical Wind Speed',
    机械风风向: 'Mechanical Wind Direction',
    PWD20能见度: 'PWD20 Visibility',
    PWD20降水强度: 'PWD20 Precipitation Intensity',
    PTB210压力hPa: 'PTB210 Pressure hPa',
    'SPP短波辐射Wm^-2': 'SPP Shortwave Radiation Wm^-2',
    'PIR长波辐射Wm^-2': 'PIR Longwave Radiation Wm^-2',
    '50203雨量mm': '50203 Rainfall mm',
    'HMP温度℃': 'HMP Temperature ℃',
    'HMP湿度%RH': 'HMP Humidity %RH',
    'CO2-ppm': 'CO2-ppm',
    'E/W8-mm/s': 'E/W8-mm/s',
    'E/W9-mm/s': 'E/W9-mm/s',
    'E/W11-mm/s': 'E/W11-mm/s',
    'E/W10-mm/s': 'E/W10-mm/s',
    'E/W12-mm/s': 'E/W12-mm/s',
    'E/W13-mm/s': 'E/W13-mm/s',
    'E/W14-mm/s': 'E/W14-mm/s',
    'E/W15-mm/s': 'E/W15-mm/s',
    'E/W16-mm/s': 'E/W16-mm/s',
    'E/W17-mm/s': 'E/W17-mm/s',
    'E/W18-mm/s': 'E/W18-mm/s',
    'E/W19-mm/s': 'E/W19-mm/s',
    'E/W20-mm/s': 'E/W20-mm/s',
    'N/S8-mm/s': 'N/S8-mm/s',
    'N/S9-mm/s': 'N/S9-mm/s',
    'N/S11-mm/s': 'N/S11-mm/s',
    'N/S10-mm/s': 'N/S10-mm/s',
    'N/S12-mm/s': 'N/S12-mm/s',
    'N/S13-mm/s': 'N/S13-mm/s',
    'N/S14-mm/s': 'N/S14-mm/s',
    'N/S15-mm/s': 'N/S15-mm/s',
    'N/S16-mm/s': 'N/S16-mm/s',
    'N/S17-mm/s': 'N/S17-mm/s',
    'N/S18-mm/s': 'N/S18-mm/s',
    'N/S19-mm/s': 'N/S19-mm/s',
    'N/S20-mm/s': 'N/S20-mm/s',
    DH22温度: 'DH22 Temperature',
    DH22湿度: 'DH22 Humidity',
    pH: 'pH',
    'HDO(%Sat)': 'HDO(%Sat)',
    P波向: 'P Wave Direction ',
    A波向: 'A Wave Direction ',
    TD01温度: 'TD01 Temperature',
    TD01压力: 'TD01 Pressure',
    TD02温度: 'TD02 Temperature',
    TD02压力: 'TD02 Pressure',
    TD03温度: 'TD03 Temperature',
    TD03压力: 'TD03 Pressure',
    TD04温度: 'TD04 Temperature',
    TD04压力: 'TD04 Pressure',
    TD05温度: 'TD05 Temperature',
    TD05压力: 'TD05 Pressure',
    TD06温度: 'TD06 Temperature',
    TD06压力: 'TD06 Pressure',
    TD07温度: 'TD07 Temperature',
    TD07压力: 'TD07 Pressure',
    TD08温度: 'TD08 Temperature',
    TD08压力: 'TD08 Pressure',
    TD09温度: 'TD09 Temperature',
    TD09压力: 'TD09 Pressure',
    TD10温度: 'TD10 Temperature',
    TD10压力: 'TD10 Pressure',
    CTD01温度: 'CTD01 Temperature',
    CTD01电导率: 'CTD01 Conductivity',
    CTD01压力: 'CTD01 Pressure',
    CTD02温度: 'CTD02 Temperature',
    CTD02电导率: 'CTD02 Conductivity',
    CTD02压力: 'CTD02 Pressure',
    CTD03温度: 'CTD03 Temperature',
    CTD03电导率: 'CTD03 Conductivity',
    CTD03压力: 'CTD03 Pressure',
    CTD04温度: 'CTD04 Temperature',
    CTD04电导率: 'CTD04 Conductivity',
    CTD04压力: 'CTD04 Pressure',
    CTD05温度: 'CTD05 Temperature',
    CTD05电导率: 'CTD05 Conductivity',
    CTD05压力: 'CTD05 Pressure',
    'NORTEK-E-speed': 'NORTEK-E-speed',
    'NORTEK-N-speed': 'NORTEK-N-speed',
    'NORTEK-U-speed': 'NORTEK-U-speed',
    'NORTEK-BEAM1': 'NORTEK-BEAM1',
    'NORTEK-BEAM2': 'NORTEK-BEAM2',
    'NORTEK-BEAM3': 'NORTEK-BEAM3',
    'NORTEK-PRESS': 'NORTEK-PRESS',
    'NORTEK-TEMP': 'NORTEK-TEMP',
    'NORTEK-SPEED': 'NORTEK-SPEED',
    'NORTEK-DIR': 'NORTEK-DIR',
    水下CO2: 'CO2 in water',
    '水下CO2-ppm': 'CO2 in water -ppm',
    '水上CO2-μmol/mol': 'CO2 in air -μmol/mol',
    水听器01: 'Hydrophone 01',
    水听器02: 'Hydrophone 02',
    水听器03: 'Hydrophone 03',
    水听器04: 'Hydrophone 04',
    水听器05: 'Hydrophone 05',
    水听器06: 'Hydrophone 06',
    水听器07: 'Hydrophone 07',
    水听器08: 'Hydrophone 08',
    水听器09: 'Hydrophone 09',
    水听器10: 'Hydrophone 10',
    水听器11: 'Hydrophone 11',
    水听器12: 'Hydrophone 12',
    水听器13: 'Hydrophone 13',
    水听器14: 'Hydrophone 14',
    水听器15: 'Hydrophone 15',
    水听器16: 'Hydrophone 16',
    水听器17: 'Hydrophone 17',
    水听器18: 'Hydrophone 18',
    水听器19: 'Hydrophone 19',
    水听器20: 'Hydrophone 20',
    水听器21: 'Hydrophone 21',
    水听器22: 'Hydrophone 22',
    水听器23: 'Hydrophone 23',
    水听器24: 'Hydrophone 24',
    水听器25: 'Hydrophone 25',
    水听器26: 'Hydrophone 26',
    水听器27: 'Hydrophone 27',
    水听器28: 'Hydrophone 28',
    '高程（米）': 'Elevation（m）',
    pitch: 'pitch',
    roll: 'roll',
    'X流速cm/s': 'X Flow Rate cm/s',
    'Y流速cm/s': 'Y Flow Rate cm/s',
    '流速cm/s': 'Flow Rate cm/s',
    '方位°': 'Position°',
    '流向°': 'Flow Direction°',
    'N/S流速cm/s': 'N/S Flow Rate cm/s',
    'E/W流速cm/s': 'E/W Flow Rate cm/s',
    保留字段: 'Reserve Fields',
    '溶解氧（mg/L）': 'Dissolved Oxygen（mg/L）',
    '液位值（mm）': 'Liquid Level（mm）',
    硝酸盐: 'Nitrate',
    亚硝酸盐: 'Nitrite',
    氨氮: 'Ammonia Nitrogen',
    磷酸盐: 'Phosphate',
    硅酸盐: 'Silicate',
    硝酸盐I0: 'Nitrate I0',
    硝酸盐I1: 'Nitrate I1',
    亚硝酸盐I0: 'Nitrite I0',
    亚硝酸盐I1: 'Nitrite I1',
    氨氮I0: 'Ammonia Nitrogen I0',
    氨氮I1: 'Ammonia Nitrogen I1',
    磷酸盐I0: 'Phosphate I0',
    磷酸盐I1: 'Phosphate I1',
    硅酸盐I0: 'Silicate I0',
    硅酸盐I1: 'Silicate I1',
    bWeek: 'bWeek',
    bTow: 'bTow',
    bLon: 'bLon',
    bLat: 'bLat',
    bH: 'bH',
    bWaveH: 'bWaveH',
    bWaveT: 'bWaveT',
    bZtd: 'bZtd',
    TD11温度: 'TD11 Temperature',
    TD11压力: 'TD11 Pressure',
    TD12温度: 'TD12 Temperature',
    TD12压力: 'TD12 Pressure',
    TD13温度: 'TD13 Temperature',
    TD13压力: 'TD13 Pressure',
    TD14温度: 'TD14 Temperature',
    TD14压力: 'TD14 Pressure',
    TD15温度: 'TD15 Temperature',
    TD15压力: 'TD15 Pressure',
    TD16温度: 'TD16 Temperature',
    TD16压力: 'TD16 Pressure',
    TD17温度: 'TD17 Temperature',
    TD17压力: 'TD17 Pressure',
    TD18温度: 'TD18 Temperature',
    TD18压力: 'TD18 Pressure',
    TD19温度: 'TD19 Temperature',
    TD19压力: 'TD19 Pressure',
    TD20温度: 'TD20 Temperature',
    TD20压力: 'TD20 Pressure',
    TD21温度: 'TD21 Temperature',
    TD21压力: 'TD21 Pressure',
    TD22温度: 'TD22 Temperature',
    TD22压力: 'TD22 Pressure',
    TD23温度: 'TD23 Temperature',
    TD23压力: 'TD23 Pressure',
    TD24温度: 'TD24 Temperature',
    TD24压力: 'TD24 Pressure',
    TD25温度: 'TD25 Temperature',
    TD25压力: 'TD25 Pressure',
    TD26温度: 'TD26 Temperature',
    TD26压力: 'TD26 Pressure',
    TD27温度: 'TD27 Temperature',
    TD27压力: 'TD27 Pressure',
    TD28温度: 'TD28 Temperature',
    TD28压力: 'TD28 Pressure',
    TD29温度: 'TD29 Temperature',
    TD29压力: 'TD29 Pressure',
    TD30温度: 'TD30 Temperature',
    TD30压力: 'TD30 Pressure',
    TD31温度: 'TD31 Temperature',
    TD31压力: 'TD31 Pressure',
    TD32温度: 'TD32 Temperature',
    TD32压力: 'TD32 Pressure',
    TD33温度: 'TD33 Temperature',
    TD33压力: 'TD33 Pressure',
    TD34温度: 'TD34 Temperature',
    TD34压力: 'TD34 Pressure',
    TD35温度: 'TD35 Temperature',
    TD35压力: 'TD35 Pressure',
    表层温度: 'Surface Humidity',
    表层盐度: 'Surface Salinity',
    波向02: 'Wave Direction 02',
    '水深01（m）': 'Depth 01（m）',
    '水深02（m）': 'Depth 02（m）',
    定位状态: 'Positioning Status',
    '1/3 Wave Height(m)': '1/3 Wave Height(m)',
    '1/3 Wave Period(s)': '1/3 Wave Period(s)',
    '1/10 Wave Height(m)': '1/10 Wave Height(m)',
    '1/10 Wave Period(s)': '1/10 Wave Period(s)',
    'Max Wave Height(m)': 'Max Wave Height(m)',
    'Max Wave Period(s)': 'Max Wave Period(s)',
    'Mean Wave Height (m)': 'Mean Wave Height (m)',
    'Mean Wave Period (s)': 'Mean Wave Period (s)',
    'Surge Wave Height (m)': 'Swell Wave Height',
    'Surge Wave Period (s)': 'Swell Wave Period',
    'Wave Direction': 'Wave Direction',
    'Surface Temp (℃)': 'Surface Temp (℃)',
    'voltage value (V)': 'voltage value (V)',
    Longtitude: 'Longtitude',
    Latitude: 'Latitude',
    'Wind Direction': 'Wind Direction',
    'Wind Speed (m/s)': 'Wind Speed (m/s)',
    'Air Pressure(hPa)': 'Air Pressure(hPa)',
    'Relative humidity': 'Relative humidity',
    'Temp(℃)': 'Temp(℃)',
    '电导率(mS/cm)': 'Conductivity(mS/cm)',
    '温度(℃)': 'Temperature(℃)',
    '浊度(NTU)': 'Turbidity(NTU)',
    '叶绿素a(μg/L)': 'chlorophyll a(μg/L)',
    报表: 'report',
    请完善查询条件: 'Please complete the query conditions',
    北礵三米测浪浮标: 'Three-metre Wave Buoy At North Shuang',
    时间1: 'Date',
    气压1: 'AP',
    波高1: 'WH',
    波周期1: 'WP',
    '24h最大': '24h Max',
    '24h最大风速': '24h Max Wind Speed',
    最大风速: 'Max Wind Speed',
    最大风向: 'Max Wind Direction',
    '24h最大波高': '24h Max Wave Height',
    最新: 'Up To Date',
    时间2: 'Date Time',
    时间3: 'Date & Time',
    '波高0~1米': 'Wave Height 0~1 m',
    '波高1~2米': 'Wave Height 1~2 m',
    '波高2~3米': 'Wave Height 2~3 m',
    海洋监测系统动态数据显示平台: 'Ocean Monitor System Dynamic Data Display Platform',
    'Currents Velocity01(mm/s)': 'Currents Velocity01(mm/s)',
    'Currents Velocity02(mm/s)': 'Currents Velocity02(mm/s)',
    'Currents Velocity03(mm/s)': 'Currents Velocity03(mm/s)',
    'Currents Velocity04(mm/s)': 'Currents Velocity04(mm/s)',
    'Currents Velocity05(mm/s)': 'Currents Velocity05(mm/s)',
    'Currents Velocity06(mm/s)': 'Currents Velocity06(mm/s)',
    'Currents Velocity07(mm/s)': 'Currents Velocity07(mm/s)',
    'Currents Velocity08(mm/s)': 'Currents Velocity08(mm/s)',
    'Currents Velocity09(mm/s)': 'Currents Velocity09(mm/s)',
    'Currents Velocity10(mm/s)': 'Currents Velocity10(mm/s)',
    'Currents Velocity11(mm/s)': 'Currents Velocity11(mm/s)',
    'Currents Velocity12(mm/s)': 'Currents Velocity12(mm/s)',
    'Currents Velocity13(mm/s)': 'Currents Velocity13(mm/s)',
    'Currents Velocity14(mm/s)': 'Currents Velocity14(mm/s)',
    'Currents direction01(°)': 'Currents direction01(°)',
    'Currents direction02(°)': 'Currents direction02(°)',
    'Currents direction03(°)': 'Currents direction03(°)',
    'Currents direction04(°)': 'Currents direction04(°)',
    'Currents direction05(°)': 'Currents direction05(°)',
    'Currents direction06(°)': 'Currents direction06(°)',
    'Currents direction07(°)': 'Currents direction07(°)',
    'Currents direction08(°)': 'Currents direction08(°)',
    'Currents direction09(°)': 'Currents direction09(°)',
    'Currents direction10(°)': 'Currents direction10(°)',
    'Currents direction11(°)': 'Currents direction11(°)',
    'Currents direction12(°)': 'Currents direction12(°)',
    'Currents direction13(°)': 'Currents direction13(°)',
    'Currents direction14(°)': 'Currents direction14(°)',
    'wind speed': 'wind speed',
    'wind direction': 'wind direction',
    'Temp': 'Temp',
    'RH': 'RH',
    'surface pressure': 'surface pressure',
    'Precipitation': 'Precipitation',
    'Voltage value': 'Voltage value',
    'Mean Wave Height(m)': 'Mean Wave Height(m)',
    'Mean Wave Period(s)': 'Mean Wave Period(s)',
    'Surge Wave Height(m)': 'Surge Wave Height(m)',
    'Surge Wave Period(s)': 'Surge Wave Period(s)',
    'Surface Temp(℃)': 'Surface Temp(℃)',
    'voltage value(V)': 'voltage value(V)',
    'Wind Speed(m/s)': 'Wind Speed(m/s)',
    'Currents Velocity15(mm/s)至Currents Velocity25(mm/s)': 'Currents Velocity15(mm/s)至Currents Velocity25(mm/s)',
    'Currents direction15(°)至Currents direction25(°)': 'Currents direction15(°)至Currents direction25(°)',
    'weather-status': 'weather-status',
    'wave-status': 'wave-status',
    'gps-status': 'gps-status',
    'adcp-status': 'adcp-status',
    //设备Met Buoy参数
    'Wave Direction(°)': 'Wave Direction(°)',
    'Voltage Value(V)': 'Voltage Value(V)',
    'Weather Status': 'Weather Status',
    'Wave Status': 'Wave Status',
    'GPS Status': 'GPS Status',
    'ADCP Status': 'ADCP Status',
    'Current Velocity 01(mm/s)': 'Current Velocity 01(mm/s)',
    'Current Velocity 02(mm/s)': 'Current Velocity 02(mm/s)',
    'Current Velocity 03(mm/s)': 'Current Velocity 03(mm/s)',
    'Current Velocity 04(mm/s)': 'Current Velocity 04(mm/s)',
    'Current Velocity 05(mm/s)': 'Current Velocity 05(mm/s)',
    'Current Velocity 06(mm/s)': 'Current Velocity 06(mm/s)',
    'Current Velocity 07(mm/s)': 'Current Velocity 07(mm/s)',
    'Current Velocity 08(mm/s)': 'Current Velocity 08(mm/s)',
    'Current Velocity 09(mm/s)': 'Current Velocity 09(mm/s)',
    'Current Velocity 10(mm/s)': 'Current Velocity 10(mm/s)',
    'Current Velocity 11(mm/s)': 'Current Velocity 11(mm/s)',
    'Current Velocity 12(mm/s)': 'Current Velocity 12(mm/s)',
    'Current Velocity 13(mm/s)': 'Current Velocity 13(mm/s)',
    'Current Velocity 14(mm/s)': 'Current Velocity 14(mm/s)',
    'Current Velocity 15(mm/s)': 'Current Velocity 15(mm/s)',
    'Current Velocity 16(mm/s)': 'Current Velocity 16(mm/s)',
    'Current Velocity 17(mm/s)': 'Current Velocity 17(mm/s)',
    'Current Velocity 18(mm/s)': 'Current Velocity 18(mm/s)',
    'Current Velocity 19(mm/s)': 'Current Velocity 19(mm/s)',
    'Current Velocity 20(mm/s)': 'Current Velocity 20(mm/s)',
    'Current Velocity 21(mm/s)': 'Current Velocity 21(mm/s)',
    'Current Velocity 22(mm/s)': 'Current Velocity 22(mm/s)',
    'Current Velocity 23(mm/s)': 'Current Velocity 23(mm/s)',
    'Current Velocity 24(mm/s)': 'Current Velocity 24(mm/s)',
    'Current Velocity 25(mm/s)': 'Current Velocity 25(mm/s)',
    'Current Direction 01(°)': 'Current Direction 01(°)',
    'Current Direction 02(°)': 'Current Direction 02(°)',
    'Current Direction 03(°)': 'Current Direction 03(°)',
    'Current Direction 04(°)': 'Current Direction 04(°)',
    'Current Direction 05(°)': 'Current Direction 05(°)',
    'Current Direction 06(°)': 'Current Direction 06(°)',
    'Current Direction 07(°)': 'Current Direction 07(°)',
    'Current Direction 08(°)': 'Current Direction 08(°)',
    'Current Direction 09(°)': 'Current Direction 09(°)',
    'Current Direction 10(°)': 'Current Direction 10(°)',
    'Current Direction 11(°)': 'Current Direction 11(°)',
    'Current Direction 12(°)': 'Current Direction 12(°)',
    'Current Direction 13(°)': 'Current Direction 13(°)',
    'Current Direction 14(°)': 'Current Direction 14(°)',
    'Current Direction 15(°)': 'Current Direction 15(°)',
    'Current Direction 16(°)': 'Current Direction 16(°)',
    'Current Direction 17(°)': 'Current Direction 17(°)',
    'Current Direction 18(°)': 'Current Direction 18(°)',
    'Current Direction 19(°)': 'Current Direction 19(°)',
    'Current Direction 20(°)': 'Current Direction 20(°)',
    'Current Direction 21(°)': 'Current Direction 21(°)',
    'Current Direction 22(°)': 'Current Direction 22(°)',
    'Current Direction 23(°)': 'Current Direction 23(°)',
    'Current Direction 24(°)': 'Current Direction 24(°)',
    'Current Direction 25(°)': 'Current Direction 25(°)',
    //
    'Currents direction15(°)': 'Currents direction15(°)',
    'Currents direction16(°)': 'Currents direction16(°)',
    'Currents direction17(°)': 'Currents direction17(°)',
    'Currents direction18(°)': 'Currents direction18(°)',
    'Currents direction19(°)': 'Currents direction19(°)',
    'Currents direction20(°)': 'Currents direction20(°)',
    'Currents direction21(°)': 'Currents direction21(°)',
    'Currents direction22(°)': 'Currents direction22(°)',
    'Currents direction23(°)': 'Currents direction23(°)',
    'Currents direction24°)': 'Currents direction24(°)',
    'Currents direction25(°)': 'Currents direction25(°)',
    'Currents Velocity15(mm/s)': 'Currents Velocity15(mm/s)',
    'Currents Velocity16(mm/s)': 'Currents Velocity16(mm/s)',
    'Currents Velocity17(mm/s)': 'Currents Velocity17(mm/s)',
    'Currents Velocity18(mm/s)': 'Currents Velocity18(mm/s)',
    'Currents Velocity19(mm/s)': 'Currents Velocity19(mm/s)',
    'Currents Velocity20(mm/s)': 'Currents Velocity20(mm/s)',
    'Currents Velocity21(mm/s)': 'Currents Velocity21(mm/s)',
    'Currents Velocity22(mm/s)': 'Currents Velocity22(mm/s)',
    'Currents Velocity23(mm/s)': 'Currents Velocity23(mm/s)',
    'Currents Velocity24(mm/s)': 'Currents Velocity24(mm/s)',
    'Currents Velocity25(mm/s)': 'Currents Velocity25(mm/s)',
  },
  detailen: {
    首页: 'Home',
    测试页面: 'Test Page',
    配置参数: 'Configuration Parameters',
    设备名: 'Device Name',
    设备编号: 'Device Number',
    设备名称: 'Device ',
    北斗更新时间: 'Beidou Update Time',
    整点: `(o'clock)`,
    时间: 'Time',
    偏移量: 'Offset',
    米: '(Metre)',
    终端采样频率: 'Terminal Sampling Frequency',
    分: '(Minute)',
    基准纬度: 'Standard Latitude',
    度: '(Degree)',
    基准经度: 'Standard longitude',
    无信号报警间隔: 'No signal alarm interval',
    报警刷新时间: 'Alarm Refresh Time',
    查看: 'View',
    偏移报警: 'Offset Alarm',
    超时报警: 'Timeout Alarm',
    开舱漏水报警: 'Open cabin water leakage alarm',
    保存: 'Save',
    设备可见用户: 'Users with viewing permission',
    添加可见用户: 'Add a user with viewing permission',
    移除共享: 'Remove Sharing',
    设备数据: 'Device Data',
    开始日期: 'Start Date',
    至: 'to',
    结束日期: 'End Date',
    确定: 'Confirm',
    经度: 'Longitude',
    纬度: 'Latitude',
    设备报表下载: 'Device Report Download',
    添加可访问用户: 'Add Accessible Users',
    设备编码: 'Device Code',
    用户名: 'Username',
    手机号: 'Tel',
    取消: 'Cancel',
    报警列表: 'Alarm List',
    设备信息表ID: 'Device Information Digram ID',
    设备类型ID: 'Device Type ID',
    GPS时间: 'GPS Time',
    一路温度: 'One-Way Temperature',
    二路温度: 'Two-Way Temperature',
    三路温度: 'Three-Way Temperature',
    一路湿度: 'One-Way Humidity',
    二路湿度: 'Two-Way Humidity',
    三路湿度: 'Three-Way Humidity',
    是否开仓: 'Open Cabin?',
    是: 'Yes',
    否: 'No',
    操作: 'operate',
    已读: 'Read',
    选择了: 'You have selected',
    操作失败: 'Operation Failed',
    报警信息提示: 'Prompt Alarm',
    修改操作成功: 'The modification operation succeeded',
    保存成功: 'Successfully saved',
    保存失败: 'Failed to save',
    这是一段内容: 'Content',
    标题名称: 'Title',
    查询数据超过6万条: 'More than 60,000 records, the first 60,000 records are being downloaded',
    风速: 'Wind Speed',
    盐度: 'Salinity',
    气压: 'Atmospheric Pressure',
    波高: 'Wave Height',
    温度: 'Temperature',
    波值: 'Wave Value',
    波周期: 'Wave Period',
    波向: 'Wave Direction',
    电压值: 'Voltage Value',
    风向: 'Wind Direction',
    '1/3波高': '1/3 Wave Height',
    '1/3波周期': '1/3 Wave Period',
    '1/10波高': '1/10 Wave Height',
    '1/10波周期': '1/10 Wave Period',
    最大波高: 'Maximum Wave Height',
    最大波周期: 'Maximum Wave Period',
    平均波高: 'Mean Wave Height',
    平均波周期: 'Mean Wave Period',
    涌浪波高: 'Surge Wave Height',
    涌浪波周期: 'Surge Wave Period',
    'CTD温度℃': 'CTD Temperature ℃',
    'CTD电导率S/m': 'CTD Conductivity S/m',
    CTD盐度PSU: 'CTD Salinity PSU',
    'ADCP温度℃': 'ADCP Temperature ℃',
    'E/W-mm/s': 'E/W-mm/s',
    'N/S-mm/s': 'N/S-mm/s',
    Vert: 'Vert',
    CR采集器温度: 'CR Collector temperature',
    CR空气温度avg: 'CR Air Temperature avg',
    CR空气湿度avg: 'CR Air Humidity avg',
    CR水汽压avg: 'CR Water Vapor Pressure avg',
    CR气压avg: 'CR Atmospheric Pressure avg',
    CR相对风速avg: 'CR Relative Wind Speed avg',
    CR相对风向avg: 'CR Relative Wind Direction avg',
    'CR实际风速avg（knots）': 'CR Actual Wind Speed avg（knots）',
    'CR实际风速avg（m/s）': 'CR Actual Wind Speed avg（m/s）',
    'CR实际风向avg（°）': 'CR Actual Wind Direction avg（°）',
    CR长波辐射avg: 'CR Longwave Radiation avg',
    CR总辐射avg: 'CR Total Radiation avg',
    CR总辐射acc: 'CR Total Radiation acc',
    CR雨量acc: 'CR Rainfall acc',
    GMX风向: 'GMX Wind Direction',
    GMX风速: 'GMX Wind Speed',
    GMX校正后风向: 'GMX Wind Direction After Correction',
    GMX气压: 'GMX Atmospheric Pressure',
    GMX相对湿度: 'GMX Relative Humidity',
    GMX温度: 'GMX Temperature',
    GMX露点温度: 'GMX Dew Point Temperature',
    GMX雨量: 'GMX Rainfall',
    GMX降雨密度: 'GMX Rainfall Density',
    温度0: 'Temperature 0',
    经度1: 'Longitude 1',
    纬度1: 'Latitude 1',
    温度1: 'Temperature 1',
    经度2: 'Longitude 2',
    纬度2: 'Latitude 2',
    温度2: 'Temperature 2',
    经度3: 'Longitude 3',
    纬度3: 'Latitude 3',
    温度3: 'Temperature 3',
    经度4: 'Longitude 4',
    纬度4: 'Latitude 4',
    温度4: 'Temperature 4',
    信息编号: 'Message Numver',
    CTD压力db: 'CTD Pressure db',
    GMX校正后风速: 'GMX Wind Speed After Correction',
    GMX风向avg: 'GMX Wind Direction avg',
    GMX风速avg: 'GMX Wind Speed avg',
    GMX校正后风向avg: 'GMX Wind Direction After Correction avg',
    GMX校正后风速avg: 'GMX Wind Speed After Correction avg',
    GMX平均纬度整数: 'GMX Mean Latitude Degree',
    GMX平均纬度分数: 'GMX Mean Latitude Minute',
    GMX平均经度整数: 'GMX Mean Longitude Degree',
    GMX平均经度分数: 'GMX Mean Longitude Minute',
    GMX平均海拔: 'GMX Average Altitude',
    GMX总雨量: 'GMX Total Rainfall',
    GMX经度: 'GMX Longitude',
    GMX纬度: 'GMX Latitude',
    GMX海拔: 'GMX Altitude',
    'E/W1-mm/s': 'E/W1-mm/s',
    'E/W2-mm/s': 'E/W2-mm/s',
    'E/W3-mm/s': 'E/W3-mm/s',
    'E/W4-mm/s': 'E/W4-mm/s',
    'E/W5-mm/s': 'E/W5-mm/s',
    'E/W6-mm/s': 'E/W6-mm/s',
    'E/W7-mm/s': 'E/W7-mm/s',
    'N/S1-mm/s': 'N/S1-mm/s',
    'N/S2-mm/s': 'N/S2-mm/s',
    'N/S3-mm/s': 'N/S3-mm/s',
    'N/S4-mm/s': 'N/S4-mm/s',
    'N/S5-mm/s': 'N/S5-mm/s',
    'N/S6-mm/s': 'N/S6-mm/s',
    'N/S7-mm/s': 'N/S7-mm/s',
    VERT1: 'VERT1',
    VERT2: 'VERT2',
    VERT3: 'VERT3',
    VERT4: 'VERT4',
    VERT5: 'VERT5',
    VERT6: 'VERT6',
    VERT7: 'VERT7',
    ERR1: 'ERR1',
    ERR2: 'ERR2',
    ERR3: 'ERR3',
    ERR4: 'ERR4',
    ERR5: 'ERR5',
    ERR6: 'ERR6',
    ERR7: 'ERR7',
    ECHO11: 'ECHO11',
    ECHO12: 'ECHO12',
    ECHO13: 'ECHO13',
    ECHO14: 'ECHO14',
    ECHO15: 'ECHO15',
    ECHO16: 'ECHO16',
    ECHO17: 'ECHO17',
    ECHO21: 'ECHO21',
    ECHO22: 'ECHO22',
    ECHO23: 'ECHO23',
    ECHO24: 'ECHO24',
    ECHO25: 'ECHO25',
    ECHO26: 'ECHO26',
    ECHO27: 'ECHO27',
    ECHO31: 'ECHO31',
    ECHO32: 'ECHO32',
    ECHO33: 'ECHO33',
    ECHO34: 'ECHO34',
    ECHO35: 'ECHO35',
    ECHO36: 'ECHO36',
    ECHO37: 'ECHO37',
    ECHO41: 'ECHO41',
    ECHO42: 'ECHO42',
    ECHO43: 'ECHO43',
    ECHO44: 'ECHO44',
    ECHO45: 'ECHO45',
    ECHO46: 'ECHO46',
    ECHO47: 'ECHO47',
    包号: 'Datagram Number',
    谱峰周期: 'Spectral Peak Period',
    机械风风速: 'Mechanical Wind Speed',
    机械风风向: 'Mechanical Wind Direction',
    PWD20能见度: 'PWD20 Visibility',
    PWD20降水强度: 'PWD20 Precipitation Intensity',
    PTB210压力hPa: 'PTB210 Pressure hPa',
    'SPP短波辐射Wm^-2': 'SPP Shortwave Radiation Wm^-2',
    'PIR长波辐射Wm^-2': 'PIR Longwave Radiation Wm^-2',
    '50203雨量mm': '50203 Rainfall mm',
    'HMP温度℃': 'HMP Temperature ℃',
    'HMP湿度%RH': 'HMP Humidity %RH',
    'CO2-ppm': 'CO2-ppm',
    'E/W8-mm/s': 'E/W8-mm/s',
    'E/W9-mm/s': 'E/W9-mm/s',
    'E/W11-mm/s': 'E/W11-mm/s',
    'E/W10-mm/s': 'E/W10-mm/s',
    'E/W12-mm/s': 'E/W12-mm/s',
    'E/W13-mm/s': 'E/W13-mm/s',
    'E/W14-mm/s': 'E/W14-mm/s',
    'E/W15-mm/s': 'E/W15-mm/s',
    'E/W16-mm/s': 'E/W16-mm/s',
    'E/W17-mm/s': 'E/W17-mm/s',
    'E/W18-mm/s': 'E/W18-mm/s',
    'E/W19-mm/s': 'E/W19-mm/s',
    'E/W20-mm/s': 'E/W20-mm/s',
    'N/S8-mm/s': 'N/S8-mm/s',
    'N/S9-mm/s': 'N/S9-mm/s',
    'N/S11-mm/s': 'N/S11-mm/s',
    'N/S10-mm/s': 'N/S10-mm/s',
    'N/S12-mm/s': 'N/S12-mm/s',
    'N/S13-mm/s': 'N/S13-mm/s',
    'N/S14-mm/s': 'N/S14-mm/s',
    'N/S15-mm/s': 'N/S15-mm/s',
    'N/S16-mm/s': 'N/S16-mm/s',
    'N/S17-mm/s': 'N/S17-mm/s',
    'N/S18-mm/s': 'N/S18-mm/s',
    'N/S19-mm/s': 'N/S19-mm/s',
    'N/S20-mm/s': 'N/S20-mm/s',
    DH22温度: 'DH22 Temperature',
    DH22湿度: 'DH22 Humidity',
    pH: 'pH',
    'HDO(%Sat)': 'HDO(%Sat)',
    P波向: 'P Wave Direction ',
    A波向: 'A Wave Direction ',
    TD01温度: 'TD01 Temperature',
    TD01压力: 'TD01 Pressure',
    TD02温度: 'TD02 Temperature',
    TD02压力: 'TD02 Pressure',
    TD03温度: 'TD03 Temperature',
    TD03压力: 'TD03 Pressure',
    TD04温度: 'TD04 Temperature',
    TD04压力: 'TD04 Pressure',
    TD05温度: 'TD05 Temperature',
    TD05压力: 'TD05 Pressure',
    TD06温度: 'TD06 Temperature',
    TD06压力: 'TD06 Pressure',
    TD07温度: 'TD07 Temperature',
    TD07压力: 'TD07 Pressure',
    TD08温度: 'TD08 Temperature',
    TD08压力: 'TD08 Pressure',
    TD09温度: 'TD09 Temperature',
    TD09压力: 'TD09 Pressure',
    TD10温度: 'TD10 Temperature',
    TD10压力: 'TD10 Pressure',
    CTD01温度: 'CTD01 Temperature',
    CTD01电导率: 'CTD01 Conductivity',
    CTD01压力: 'CTD01 Pressure',
    CTD02温度: 'CTD02 Temperature',
    CTD02电导率: 'CTD02 Conductivity',
    CTD02压力: 'CTD02 Pressure',
    CTD03温度: 'CTD03 Temperature',
    CTD03电导率: 'CTD03 Conductivity',
    CTD03压力: 'CTD03 Pressure',
    CTD04温度: 'CTD04 Temperature',
    CTD04电导率: 'CTD04 Conductivity',
    CTD04压力: 'CTD04 Pressure',
    CTD05温度: 'CTD05 Temperature',
    CTD05电导率: 'CTD05 Conductivity',
    CTD05压力: 'CTD05 Pressure',
    'NORTEK-E-speed': 'NORTEK-E-speed',
    'NORTEK-N-speed': 'NORTEK-N-speed',
    'NORTEK-U-speed': 'NORTEK-U-speed',
    'NORTEK-BEAM1': 'NORTEK-BEAM1',
    'NORTEK-BEAM2': 'NORTEK-BEAM2',
    'NORTEK-BEAM3': 'NORTEK-BEAM3',
    'NORTEK-PRESS': 'NORTEK-PRESS',
    'NORTEK-TEMP': 'NORTEK-TEMP',
    'NORTEK-SPEED': 'NORTEK-SPEED',
    'NORTEK-DIR': 'NORTEK-DIR',
    水下CO2: 'CO2 in water',
    '水下CO2-ppm': 'CO2 in water -ppm',
    '水上CO2-μmol/mol': 'CO2 in air -μmol/mol',
    水听器01: 'Hydrophone 01',
    水听器02: 'Hydrophone 02',
    水听器03: 'Hydrophone 03',
    水听器04: 'Hydrophone 04',
    水听器05: 'Hydrophone 05',
    水听器06: 'Hydrophone 06',
    水听器07: 'Hydrophone 07',
    水听器08: 'Hydrophone 08',
    水听器09: 'Hydrophone 09',
    水听器10: 'Hydrophone 10',
    水听器11: 'Hydrophone 11',
    水听器12: 'Hydrophone 12',
    水听器13: 'Hydrophone 13',
    水听器14: 'Hydrophone 14',
    水听器15: 'Hydrophone 15',
    水听器16: 'Hydrophone 16',
    水听器17: 'Hydrophone 17',
    水听器18: 'Hydrophone 18',
    水听器19: 'Hydrophone 19',
    水听器20: 'Hydrophone 20',
    水听器21: 'Hydrophone 21',
    水听器22: 'Hydrophone 22',
    水听器23: 'Hydrophone 23',
    水听器24: 'Hydrophone 24',
    水听器25: 'Hydrophone 25',
    水听器26: 'Hydrophone 26',
    水听器27: 'Hydrophone 27',
    水听器28: 'Hydrophone 28',
    '高程（米）': 'Elevation（m）',
    pitch: 'pitch',
    roll: 'roll',
    'X流速cm/s': 'X Flow Rate cm/s',
    'Y流速cm/s': 'Y Flow Rate cm/s',
    '流速cm/s': 'Flow Rate cm/s',
    '方位°': 'Position°',
    '流向°': 'Flow Direction°',
    'N/S流速cm/s': 'N/S Flow Rate cm/s',
    'E/W流速cm/s': 'E/W Flow Rate cm/s',
    保留字段: 'Reserve Fields',
    '溶解氧（mg/L）': 'Dissolved Oxygen（mg/L）',
    '液位值（mm）': 'Liquid Level（mm）',
    硝酸盐: 'Nitrate',
    亚硝酸盐: 'Nitrite',
    氨氮: 'Ammonia Nitrogen',
    磷酸盐: 'Phosphate',
    硅酸盐: 'Silicate',
    硝酸盐I0: 'Nitrate I0',
    硝酸盐I1: 'Nitrate I1',
    亚硝酸盐I0: 'Nitrite I0',
    亚硝酸盐I1: 'Nitrite I1',
    氨氮I0: 'Ammonia Nitrogen I0',
    氨氮I1: 'Ammonia Nitrogen I1',
    磷酸盐I0: 'Phosphate I0',
    磷酸盐I1: 'Phosphate I1',
    硅酸盐I0: 'Silicate I0',
    硅酸盐I1: 'Silicate I1',
    bWeek: 'bWeek',
    bTow: 'bTow',
    bLon: 'bLon',
    bLat: 'bLat',
    bH: 'bH',
    bWaveH: 'bWaveH',
    bWaveT: 'bWaveT',
    bZtd: 'bZtd',
    TD11温度: 'TD11 Temperature',
    TD11压力: 'TD11 Pressure',
    TD12温度: 'TD12 Temperature',
    TD12压力: 'TD12 Pressure',
    TD13温度: 'TD13 Temperature',
    TD13压力: 'TD13 Pressure',
    TD14温度: 'TD14 Temperature',
    TD14压力: 'TD14 Pressure',
    TD15温度: 'TD15 Temperature',
    TD15压力: 'TD15 Pressure',
    TD16温度: 'TD16 Temperature',
    TD16压力: 'TD16 Pressure',
    TD17温度: 'TD17 Temperature',
    TD17压力: 'TD17 Pressure',
    TD18温度: 'TD18 Temperature',
    TD18压力: 'TD18 Pressure',
    TD19温度: 'TD19 Temperature',
    TD19压力: 'TD19 Pressure',
    TD20温度: 'TD20 Temperature',
    TD20压力: 'TD20 Pressure',
    TD21温度: 'TD21 Temperature',
    TD21压力: 'TD21 Pressure',
    TD22温度: 'TD22 Temperature',
    TD22压力: 'TD22 Pressure',
    TD23温度: 'TD23 Temperature',
    TD23压力: 'TD23 Pressure',
    TD24温度: 'TD24 Temperature',
    TD24压力: 'TD24 Pressure',
    TD25温度: 'TD25 Temperature',
    TD25压力: 'TD25 Pressure',
    TD26温度: 'TD26 Temperature',
    TD26压力: 'TD26 Pressure',
    TD27温度: 'TD27 Temperature',
    TD27压力: 'TD27 Pressure',
    TD28温度: 'TD28 Temperature',
    TD28压力: 'TD28 Pressure',
    TD29温度: 'TD29 Temperature',
    TD29压力: 'TD29 Pressure',
    TD30温度: 'TD30 Temperature',
    TD30压力: 'TD30 Pressure',
    TD31温度: 'TD31 Temperature',
    TD31压力: 'TD31 Pressure',
    TD32温度: 'TD32 Temperature',
    TD32压力: 'TD32 Pressure',
    TD33温度: 'TD33 Temperature',
    TD33压力: 'TD33 Pressure',
    TD34温度: 'TD34 Temperature',
    TD34压力: 'TD34 Pressure',
    TD35温度: 'TD35 Temperature',
    TD35压力: 'TD35 Pressure',
    表层温度: 'Surface Humidity',
    表层盐度: 'Surface Salinity',
    波向02: 'Wave Direction 02',
    '水深01（m）': 'Depth 01（m）',
    '水深02（m）': 'Depth 02（m）',
    定位状态: 'Positioning Status',
    '1/3 Wave Height(m)': '1/3 Wave Height(m)',
    '1/3 Wave Period(s)': '1/3 Wave Period(s)',
    '1/10 Wave Height(m)': '1/10 Wave Height(m)',
    '1/10 Wave Period(s)': '1/10 Wave Period(s)',
    'Max Wave Height(m)': 'Max Wave Height(m)',
    'Max Wave Period(s)': 'Max Wave Period(s)',
    'Mean Wave Height (m)': 'Mean Wave Height (m)',
    'Mean Wave Period (s)': 'Mean Wave Period (s)',
    'Surge Wave Height (m)': 'Swell Wave Height',
    'Surge Wave Period (s)': 'Swell Wave Period',
    'Wave Direction': 'Wave Direction',
    'Surface Temp (℃)': 'Surface Temp (℃)',
    'voltage value (V)': 'voltage value (V)',
    Longtitude: 'Longtitude',
    Latitude: 'Latitude',
    'GMX Wind Direction': 'GMX Wind Direction',
    'GMX Wind Speed (m/s)': 'GMX Wind Speed (m/s)',
    'GMX Air Pressure(hPa)': 'GMX Air Pressure(hPa)',
    'GMX Relative humidity': 'GMX Relative humidity',
    'GMX Temp(℃)': 'GMX Temp(℃)',
    '电导率(mS/cm)': 'Conductivity(mS/cm)',
    '温度(℃)': 'Temperature(℃)',
    '浊度(NTU)': 'Turbidity(NTU)',
    '叶绿素a(μg/L)': 'chlorophyll a(μg/L)',
    报表: 'report',
    请完善查询条件: 'Please complete the query conditions',
    北礵三米测浪浮标: 'Three-metre Wave Buoy At North Shuang',
    时间1: 'Date',
    气压1: 'AP',
    波高1: 'WH',
    波周期1: 'WP',
    '24h最大': '24h Max',
    '24h最大风速': '24h Max Wind Speed',
    最大风速: 'Max Wind Speed',
    最大风向: 'Max Wind Direction',
    '24h最大波高': '24h Max Wave Height',
    最新: 'Up To Date',
    时间2: 'Date Time',
    时间3: 'Date & Time',
    '波高0~1米': 'Wave Height 0~1 m',
    '波高1~2米': 'Wave Height 1~2 m',
    '波高2~3米': 'Wave Height 2~3 m',
    海洋监测系统动态数据显示平台: 'Ocean Monitor System Dynamic Data Display Platform'
  },
  report: {
    首页: 'Home',
    设备报表: 'Device Report',
    筛选条件: 'Filter Conditions',
    请选择设备类型: 'Select Device Type',
    请选择设备: 'Select Device',
    请设备参数: 'Device Parameters',
    开始日期: 'Start Date',
    至: 'to',
    结束日期: 'End Date',
    生成报表图: 'Generate Report Graph',
    选择了: 'You have selected',
    请完善查询条件: 'Please improve query conditions',
    报表: 'Report'
  },
  allExcelData: {
    首页: 'Home',
    数据批量导出: 'Export Multiple Data',
    筛选条件: 'Filter Conditions',
    数据开始日期: 'Start Date',
    数据结束日期: 'End Date',
    至: 'to',
    批量导出: 'Batch Export',
    压缩中: 'Compressing',
    全选: 'Check All',
    请选择导出内容: 'Select Documents',
    时间: 'Time',
    经度: 'Longitude',
    纬度: 'Latitude',
    正在导出: 'Exporting',
    问题数据: 'Problematic Data:'
  },
  dashBoard: {
    首页: 'Home'
  },
  home: {
    激活设备: 'Activating device',
    修改密码: 'Change Password',
    退出登录: 'Log 0ut',
    排序方式: 'Sortord',
    设备编码: 'Equipment Coding',
    设备名称: 'Devicename',
    我的设备: 'My Device',
    检索设备: 'Retrieve Device',
    数据批量导出: 'Data Batch Export',
    设备报表: 'Equipment Report',
    地图: 'Map',
    波谱: 'Spectrum',
    广告机: 'Advertising Machine',
    看板: 'Kanban',
    其它设备: 'Other Device',
    noData: 'No Data',
    title: 'Dash Board',
    登录成功: 'Login Suceed',
    登录失败: 'Login Lose',
    看板1: 'Dash Board'
  },
  Monitoring5638: {
    '1/3波高': '1/3 WH (m)',
    '1/3波周期': '1/3 WP (s)',
    风速: 'WS (m/s)',
    风向: 'WD (°)',
    温度: 'Temp (°C)',
    湿度: 'Hum (°C)',
    气压: 'AP (hPa)'
  },
  Monitoring1025: {
    banner: 'Ocean Monitor System Dynamic Data Display Platform',
    bouyName: 'Buoy Name',
    utcTime: 'Data Time(UTC)',
    currentTime: 'Local Time',
    meteoData: 'METEOROLOGICAL DATA',
    humidity: 'Humidity',
    pressure: 'Pressure',
    windSpeed: 'Wind Speed',
    temp: 'Temperature',
    hydroData: 'HYDROLOGICAL DATA',
    waveHeight: 'Wave Height',
    waveDirection: 'Wave Direction',
    wavePeriod: 'Wave Period',
    surfaceTemp: 'Surface Temperature',
    currentVelocity: 'Current Velocity',
    currentDirection: 'Current Direction',
    waveGrade: 'WAVE GRADE',
    surfaceCurrent: 'SURFACE CURRENT',
    historyData: 'HISTORICAL DATA TIME SERIAL',
    timeSlot: 'Time Slot',
    startTime: 'Start',
    endTime: 'End',
    confirm: 'Confirm',
    element: 'Element',
    windDirection: 'Wind Direction',
    airPressure: 'Air Pressure',
    currentSpeedProfile: 'CURRENT VELOCITY',
    alarm: 'ALARM',
    time: 'TIME',
    type: 'TYPE',
    content: 'CONTENT',
    waveRoseDiagram: 'WAVE ROSE DIAGRAM',
    currentSpeed: 'Current Velocity',
    overSideAlarm: 'Displacement Deviation Alarm', // 偏移报警
    leakWaterAlarm: 'Water Leakage Alarm', // 开仓漏水报警
    timeOutAlarm: 'Timeout Alarm', // 超时报警
    outLimitAlarm: 'Upper and Lower Limit Alarm', // 超限报警
    errorDataAlarm: 'Abnormal Data Alarm', // 错误数据报警

    overSideAlarmContent: 'The device position is offset by {0} m. Pay attention to the safe operation of the equipment.',
    leakWaterAlarmContent: 'The device is in danger of leaking. Pay attention to the safe operation of the equipment.',
    timeOutAlarmContent: 'Device information cannot be returned properly. Note that the device is running properly.',
    outLimitAlarmContent: 'The device measurement {0} has exceeded the {1} limit {2} . Please pay attention to the equipment measurement.',
    errorDataAlarmContent: 'The device data is abnormal. Please check the device running status.',

    selectTime: 'Select Time'
  },
 '表面漂流浮标-国际版':'Surface Drifting Buoy-Intl. Version',
 '表面漂流浮标':'Surface Drifting Buoy',
}
